import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ChallengeInlineDialogExpiredData {
  data?: any;
  errorMsg?: string;
}


type AuthState = 'loading' | 'expired' | 'failed';

@Component({
  selector: 'app-challenge-inline-dialog-expired',
  templateUrl: './challenge-inline-dialog-expired.component.html',
  styleUrls: ['./challenge-inline-dialog-expired.component.scss']
})

export class ChallengeInlineDialogExpiredComponent implements OnInit {
  deviceName = 'device';
  state: AuthState = 'loading';
  test: boolean = true;
  errorMsg = '';
  expiresIn?: number;      // initial seconds from server
  remainingSec?: number;   // countdown
  isExpired: boolean = true;
  isFailed: boolean = true;

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: ChallengeInlineDialogExpiredData) { }

  ngOnInit(): void {
    this.isExpired = this.dialogData?.data?.isExpired;
    this.isFailed = this.dialogData?.data?.isFailed;
    this.errorMsg = this.dialogData?.errorMsg || 'Authentication failed. Please try again.';
  }

  /** Call this from parent or inside to switch to "failed" state */
  setError(msg: string) {
    this.errorMsg = msg || 'Authentication failed. Please try again.';
    this.state = 'failed';
  }

}
